import { Injectable, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { catchError, tap } from 'rxjs/operators';
import { Product } from '@shared/models';

@Injectable()
export class ProductService implements OnDestroy {
    private httpService = inject(HttpService);

    product$ = new BehaviorSubject<Product | null>(null);
    error$ = new BehaviorSubject<boolean>(false);

    private subscriptions = new Subscription();
    dispatch(slug: string): void {
        this.error$.next(false);
        this.subscriptions.add(
            this.httpService
                .getProduct(slug)
                .pipe(
                    tap((product) => this.product$.next(product)),
                    catchError((error) => {
                        this.error$.next(true);
                        return of(error);
                    }),
                )
                .subscribe(),
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
